module.exports = __webpack_public_path__ + "img/moer.f3135e3f.png";